/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

function FooterBlack() {
  return (
    <footer className="edge-footer">
      <div className="edge-footer-grid">
        <div>
          <div className="edge-footer-brand">Edge<span>Ventures</span></div>
          <p className="edge-footer-tagline">
            We build the systems that move the numbers you're accountable for.
            <br /><br />
            © {new Date().getFullYear()} Edge Ventures INC.
          </p>
        </div>
        <div>
          <div className="edge-footer-col-title">Services</div>
          <ul className="edge-footer-links">
            <li><Link to="/ai-agents">AI Agents</Link></li>
            <li><Link to="/consulting">Consulting</Link></li>
            <li><Link to="/open-source">Open Source</Link></li>
            <li><Link to="/products">Product Support</Link></li>
          </ul>
        </div>
        <div>
          <div className="edge-footer-col-title">Company</div>
          <ul className="edge-footer-links">
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="edge-footer-col-title">Contact</div>
          <ul className="edge-footer-links">
            <li><a href="tel:+13232066068">(323) 206-6068</a></li>
            <li><a href="https://blog.edgeventures.com/" target="_blank" rel="noreferrer">Don's Blog</a></li>
            <li><a href="https://www.linkedin.com/company/89898946/" target="_blank" rel="noreferrer">LinkedIn</a></li>
            <li><a href="https://github.com/Edge-Ventures/" target="_blank" rel="noreferrer">GitHub</a></li>
          </ul>
        </div>
      </div>
      <div className="edge-footer-bottom">
        <span className="edge-footer-copy">EDGE VENTURES INC · LOS ANGELES CA · {new Date().getFullYear()}</span>
        <span className="edge-footer-copy">
          <a href="tel:+13232066068">(323) 206-6068</a>
        </span>
      </div>
    </footer>
  );
}

export default FooterBlack;
